<template>
	<div class="OfferEdit quotation-sheet">
		<div class="quotation_box" v-loading='loading'>
			<el-form :rules="rules" ref='offerEditForm' label-position="right" :model="offerEditForm"
				class="quotation_form">
				<el-row type="flex" align="middle" justify="space-between" class="quotation_title">
					<div class="title_text">基本信息填写</div>
				</el-row>
				<el-row type="flex" justify="space-between" class="quotation_info">
					<div>
						<el-form-item label="报价编号" prop="order_number">
							<el-input :readonly="readonly" class="quotation_input" placeholder="请输入"
								v-model="offerEditForm.order_number"></el-input>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="客户名称" prop="customer_id">
							<el-input :readonly="readonly" class="quotation_input" placeholder="请输入"
								v-model="offerEditForm.customer_id"></el-input>
						</el-form-item>
					</div>
					<div>
					</div>
				</el-row>
				<el-row type="flex" align="middle" justify="space-between" class="quotation_title">
					<div class="title_text">报价清单如下：</div>
					<div @click="showGood" class="title_add">添加产品</div>
				</el-row>
				<el-table :row-class-name="tableRowClassName" ref='offerEditTable' class="detailTable"
					@row-dblclick="editCart" :border="border" :data="cartList" style="width: 100%"
					cell-class-name="good_text" header-cell-class-name="good_header">
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="3%"
						label="序号" class-name="is-num">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%"
						label="名称">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="hover">
								<div class="good_reference">
									<img :src="scope.row.sku_image_text" />
								</div>
								<div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column v-if="offerEditForm.category!=13&&offerEditForm.category!=19&&offerEditForm.category!=29&&offerEditForm.category!=30&&offerEditForm.category!=31&&offerEditForm.category!=40&&offerEditForm.category!=43&&offerEditForm.category!=45" :key="Math.random()" :resizable="resizeable" align="center" min-width="10%"
						label="尺寸(mm)">
						<template slot-scope="scope">
							<el-row type="flex" align="middle" justify="center" class="good_size">
								<div v-if="scope.row.goods_valuation==1">-</div>
								<div v-else>{{scope.row.size_text}}</div>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="14%"
						label="规格参数">
						<template slot-scope="scope">
							<el-row type="flex" align="middle" justify="center" class="good_size">
								<div>{{scope.row.parameter_text}}</div>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column
						v-if="offerEditForm.category==20||offerEditForm.category==25||offerEditForm.category==26||offerEditForm.category==27||offerEditForm.category==28||offerEditForm.category==32||offerEditForm.category==33||offerEditForm.category==44"
						:key="Math.random()" :resizable="resizeable" align="center" min-width="4%" prop="goods_areas"
						label="面积(㎡)" class-name="is-num">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						prop="goods_unit" label="单位">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						prop="goods_num" label="数量" class-name="is-num">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						prop="original_price" label="单价" class-name="is-amount">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						prop="singleton" label="单件价格" class-name="is-amount">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						prop="goods_original_price" label="金额" class-name="is-amount">
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="4%"
						label="参考图">
						<template slot-scope="scope">
							<el-row type="flex" align="middle" justify="center" class="good_size">
								<div class="good_icon">
									<i v-if="scope.row.reference_image&&scope.row.reference_image!=''"
										class="el-icon-picture-outline"></i>
								</div>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%"
						label="备注">
						<template slot-scope="scope">
							<el-row type="flex" align="middle" justify="center" class="good_size">
								<div>{{scope.row.remarks==""?"无":scope.row.remarks}}</div>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column :key="Math.random()" :resizable="resizeable" align="center" min-width="10%"
						label="操作">
						<template slot-scope="scope">
							<el-row type="flex" align="middle" justify="space-around">
								<el-button type="text" @click="editCart(scope.$index)">编辑</el-button>
								<el-popconfirm @onConfirm="delGood(scope.$index)" confirmButtonType="danger"
									confirmButtonText="删除" title="确定删除该产品吗？">
									<el-button type="text" slot="reference">删除</el-button>
								</el-popconfirm>
								<el-button type="text" @click="upLayer(scope.$index,scope.row)">上移</el-button>
								<el-button type="text" @click="downLayer(scope.$index,scope.row)">下移 </el-button>
							</el-row>
						</template>
					</el-table-column>
				</el-table>
				<div class="goods_footer">
					<el-row type="flex" align="middle" justify="space-between" class="goods_footer_item">
						<el-row type="flex" align="middle">
							<el-row type="flex" align="middle">
								<div class="goods_footer_text">订单备注：</div>
								<el-form-item prop="remarks">
									<el-input readonly :clearable="clearable"
										class="goods_footer_input goods_footer_remark" placeholder=""
										v-model="offerEditForm.remarks"></el-input>
								</el-form-item>
							</el-row>
						</el-row>
					</el-row>
				</div>
				<el-form-item>
					<div class="quotation_btn" @click="submitForm('offerEditForm')">确认单据</div>
				</el-form-item>
			</el-form>
			<!-- 选择产品 -->
			<el-dialog
				class="good_dialog"
				custom-class="good_dialog_panel"
				:visible.sync="goodStatus"
				:show-close="false"
				:append-to-body="true"
				:close-on-click-modal="true">
				<div class="good_dialog_body">
					<el-row type="flex" align="middle" class="list_header">
						<el-row type="flex" align="middle" class="search_box">
							<el-input @keyup.enter.native="searchGood" class="search_input" placeholder="搜索产品名称 / 关键词"
								v-model="search" clearable></el-input>
							<el-row type="flex" align="middle" justify="center" class="search_img">
								<img src="../assets/img/search.png" />
							</el-row>
							<div @click="searchGood" class="search_btn" title="搜索"></div>
						</el-row>
						<el-select @change="changeType" class="list_type" v-model="typeIndex" placeholder="选择分类">
							<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="index">
							</el-option>
						</el-select>
						<button type="button" class="good_dialog_close" title="关闭" @click="goodStatus = false">
							<i class="el-icon-close"></i>
						</button>
					</el-row>
					<div class="good_list_wrap">
						<el-table highlight-current-row ref="goodTable" @row-dblclick="chooseGood" @row-click="onGoodRowClick" @current-change="selectGood"
							:data="goodList" class="good_list" cell-class-name="good_text" header-cell-class-name="good_header">
							<el-table-column :resizable="resizeable" align="center" width="110" label="图片">
								<template slot-scope="scope">
									<el-row type="flex" justify="center" align="middle" class="good_img">
										<el-image fit="contain" :src="scope.row.image">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-row>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="40%" prop="name" label="产品名称" show-overflow-tooltip>
							</el-table-column>
							<el-table-column :resizable="resizeable" header-align="center" align="left" min-width="48%" prop="summary" label="概述" show-overflow-tooltip>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-dialog>
			<!-- 产品详情 -->
			<el-dialog class="cart_dialog" :visible.sync="cartStatus" top="5vh" :append-to-body="true">
				<div class="cart_title" slot="title">详情</div>
				<el-form :rules="cartRules" ref='cartForm' label-position="left" :model="cartForm" class="cart_form">
					<el-row v-if="good&&cartStatus" class="cart_body" type="flex">
						<div class="cart_good">
							<el-row type="flex" align="middle" class="cart_good_t">
								<el-row type="flex" justify="center" align="middle" v-if="skuActive===-1"
									class="cart_good_img">
									<el-image fit="contain"
										:src="good.cart_info?good.cart_info.goods_image_text:good.image">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</el-row>
								<el-row type="flex" justify="center" align="middle" v-else class="cart_good_img">
									<el-image fit="contain" :src="good.skuPrice[skuActive].image_url">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</el-row>
								<div>
									<div class="cart_good_name">{{good.cart_info?good.cart_info.goods_name:good.name}}
									</div>
									<div class="cart_good_tip">
										{{skuActive===-1?good.summary:good.skuPrice[skuActive].sn}}</div>
									<div class="cart_good_price">
										￥<span>{{skuActive===-1?good.price:good.skuPrice[skuActive].price}}</span></div>
								</div>
							</el-row>
							<div v-if="good.is_sku==1" class="cart_good_specs">
								<div class="cart_good_specs_box" v-for="(item,index) in good.skuList" :key="index">
									<div class="cart_good_specs_name">{{item.name}}</div>
									<el-row type="flex" class="cart_good_specs_content">
										<div @click="selectSpec(idx,index)" class="cart_good_specs_item"
											:class="{'cart_good_specs_active': idx==item.activeIndex,'cart_good_specs_no': child.noStock}"
											v-for="(child,idx) in item.children" :key="idx">{{child.name}}</div>
									</el-row>
								</div>
							</div>
							<div class="cart_good_params">
								<el-row type="flex" align="middle" class="cart_good_params_top">
									<div class="cart_good_params_title">产品参数</div>
									<div class="cart_good_params_tip">(<span>*</span>为必选项)</div>
								</el-row>
								<div class="cart_good_params_item" v-for="(item,index) in good.parameterList"
									:key="index" v-if="shouldShowParameterItem(item)">
									<el-row type="flex" class="cart_good_params_content">
										<div class="cart_good_params_name"><span
												v-if="item.must==1">*</span>{{item.name}}</div>
										<el-form-item label="" class="cart_good_params_fields">
											<template v-if="isNestedParam(item)">
												<el-select @change="selectMidParam(index)" class="cart_good_params_select cart_good_params_select--mid" v-model="item.activeMidId" placeholder="请选择电压">
													<el-option v-for="mid in item.children" :key="'mid-'+mid.id" :label="mid.name" :value="mid.id"></el-option>
												</el-select>
												<el-select @change="selectParam($event,index)" class="cart_good_params_select" v-model="item.activeId" :disabled="!item.activeMidId" placeholder="请选择色温">
													<el-option v-if="item.must!=1" :key="'leaf-empty-'+index" label="请选择" :value="''"></el-option>
													<el-option v-for="leaf in leafOptionsForMid(item, item.activeMidId)" :key="leaf.id" :label="leaf.name" :value="leaf.id"></el-option>
												</el-select>
											</template>
											<template v-else>
												<el-select @change="((val)=>{selectParam(val,index)})"
													class="cart_good_params_select" v-model="item.activeLabel"
													placeholder="请选择">
													<el-option v-for="(child,idx) in item.children" :key="child.id"
														:label="child.name" :value="child.id"></el-option>
												</el-select>
											</template>
										</el-form-item>
									</el-row>

								</div>
							</div>
						</div>
						<div class="cart_data">
							<div class="cart_data_title">计算结果<span>{{good.valuation_tips}}</span></div>
							<el-row type="flex" justify="space-between" align="bottom" class="cart_data_cal">
								<div>
									<el-row v-if="good.valuation==4||good.valuation==5||good.valuation==7||good.valuation==12||good.valuation==13" type="flex" align="middle" class="cart_data_cal_item">
										<div class="cart_data_cal_dot"></div>
										<div v-if="!good.goods_areas||good.goods_areas==''" class="cart_data_cal_name">面积：<span class="cart_data_cal_wait">待测算</span></div>
										<div v-else class="cart_data_cal_name">面积：<span>{{good.goods_areas}}</span>㎡</div>
									</el-row>
									<el-row type="flex" align="middle" class="cart_data_cal_item">
										<div class="cart_data_cal_dot"></div>
										<div v-if="!good.singleton||good.singleton==''" class="cart_data_cal_name">单件价格：<span class="cart_data_cal_wait">待测算</span></div>
										<div v-else class="cart_data_cal_name">单件价格：<span>{{good.singleton}}</span>元</div>
									</el-row>
								</div>
								<div>
									<el-button @click="calPrice" type="info">测算</el-button>
								</div>
							</el-row>
							<div class="cart_data_title">输入尺寸</div>
							<el-row type="flex" align="middle" class="cart_data_area">
								<div v-if="good.valuation==2||good.valuation==3||good.valuation==4||good.valuation==5||good.valuation==8||good.valuation==10||good.valuation==11||good.valuation==12||good.valuation==13" class="cart_data_area_item">
									<el-form-item label="长度(mm)">
										<input @input="cartForm.goods_long=cartForm.goods_long.replace(/[^\d]/g,'')" @change="priceInit()" v-model="cartForm.goods_long" class="cart_data_area_input" placeholder="请输入" />
									</el-form-item>
								</div>
								<div v-if="good.valuation==6||good.valuation==7||good.valuation==9" class="cart_data_area_item">
									<el-form-item label="高度(mm)">
										<input @input="cartForm.goods_high=cartForm.goods_high.replace(/[^\d]/g,'')" @change="priceInit()" v-model="cartForm.goods_high" class="cart_data_area_input" placeholder="请输入" />
									</el-form-item>
								</div>
								<div v-if="good.valuation==4||good.valuation==5||good.valuation==6||good.valuation==7||good.valuation==9||good.valuation==12||good.valuation==13" class="cart_data_area_item">
									<el-form-item label="宽度(mm)">
										<input @input="cartForm.goods_wide=cartForm.goods_wide.replace(/[^\d]/g,'')" @change="priceInit()" v-model="cartForm.goods_wide" class="cart_data_area_input" placeholder="请输入" />
									</el-form-item>
								</div>
								<div v-if="good.valuation==6||good.valuation==7||good.valuation==9" class="cart_data_area_item">
									<el-form-item label="厚度(mm)">
										<input @input="cartForm.goods_thick=cartForm.goods_thick.replace(/[^\d]/g,'')" @change="priceInit()" v-model="cartForm.goods_thick" class="cart_data_area_input" placeholder="请输入" />
									</el-form-item>
								</div>
							</el-row>
							<el-row type="flex" align="middle" class="cart_data_num">
								<div class="cart_data_num_text">数量</div>
								<el-input-number v-model="cartForm.goods_num" :min="1" label="数量"></el-input-number>
							</el-row>
							<el-row type="flex" justify="space-between" align="bottom" class="cart_data_bottom">
								<el-form-item class="cart_data_remark" label="备注">
									<el-input type="textarea" v-model="cartForm.remarks" maxlength="-1"
										:autosize="{ minRows: 3, maxRows: 6}" resize="none" placeholder="请输入">
									</el-input>
								</el-form-item>
								<div class="cart_btn" @click="submitCart('cartForm')">确认添加</div>
							</el-row>
							<div class="cart_data_title">参考图片</div>
							<div class="cart_data_upload">
								<imageUpload ref="avatarUpload" v-model="cartForm.reference_image" :limit="uploadLimit"
									:fileType="fileType" />
							</div>
							<div class="cart_data_tip">注：格式限制为jpg、jpeg、png、dxf、dws、dwg，小于2M</div>
						</div>
					</el-row>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import ImageUpload from "@/components/ImageUpload"
	import {
		accMul,
		accDiv,
		accAdd,
		accSub,
		getT,
		getTimestamp
	} from "../assets/js/public.js"
	import { cartDisplayName } from '@/utils/cart-display'
	import {
		isNestedParameter as isNestedParam,
		leafOptionsForMid,
		normalizeParameterList,
		onMidParameterChange,
		onLeafParameterChange,
		flatLeafParameterChange,
		shouldShowParameterItem as isParameterItemVisible,
		collectParameterIds,
		syncSwitchParameterVisibility,
	} from '@/utils/cart-parameter'
	export default {
		name: 'OfferEdit',
		components: {
			ImageUpload
		},
		data() {
			return {
				baseUrl: process.env.CDN_BASE || "http://127.0.0.1:19000/baojia-system",
				loading: !0,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				userName: '',
				offerEditForm: {
					order_number: '',
					customer_id: '',
					receiving_address: '',
					createTime: '',
					contacts: '',
					contacts_phone: '',
					delivery: '',
					invoice: '',
					total: 0,
					totalAll: 0,
					preferential: 0,
					remarks: '',
				},
				resizeable: !1,
				editable: !1,
				clearable: !0,
				showMsg: !1,
				readonly: !0,
				border: !0,
				rules: {
					order_number: [{
						required: true,
						message: '报价编号不能为空',
						trigger: 'blur'
					}],
					customer_id: [{
						required: true,
						message: '请选择客户名称',
						trigger: 'blur'
					}],
					receiving_address: [{
						required: true,
						message: '收货地址不能为空',
						trigger: 'blur'
					}],
					createTime: [{
						required: true,
						message: '请选择报价日期',
						trigger: 'blur'
					}],
					contacts: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contacts_phone: [{
						required: true,
						message: '联系电话不能为空',
						trigger: 'blur'
					}],
					delivery: [{
						required: true,
						message: '请选择运输方式',
						trigger: 'blur'
					}],
					invoice: [{
						required: true,
						message: '请选择发票类型',
						trigger: 'blur'
					}],
				},
				page: 1,
				limit: 999,
				customer: [],
				customerIndex: '',
				delivery: [],
				deliveryIndex: '',
				invoice: [],
				invoiceIndex: '',
				goodStatus: !1,
				good: null,
				goodList: [],
				cartStatus: !1,
				cartList: [],
				cartForm: {
					cart_id: "",
					goods_id: "",
					sku_ids: "",
					goods_long: "",
					goods_wide: "",
					goods_high: "",
					goods_thick: "",
					reference_image: "",
					remarks: "",
					goods_num: 1,
					goods_category: "",
					order_number: "",
					goods_size: "",
					parameter_ids: "",
				},
				cartRules: {

				},
				fileType: ["jpg", "jpeg", "png", "dxf", "dws", "dwg"],
				specIds: [],
				search: '',
				types: [],
				typeIndex: 0,
				quotationStatus: !1,
				uploadLimit: 6,
				goodActive: 0,
				skuActive: -1,
				cartSubmit: !1
			}
		},
		created() {
			this.reload();
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		beforeUpdate() {
			this.$nextTick(() => {
				this.$refs.offerEditTable.doLayout()
			})
		},
		methods: {
			cartDisplayName,
			reload() {
				let that = this
				that.getDetail()
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Cooperation/getOderDetails', {
					order_number: sessionStorage.getItem("order_number"),
					isColl: 1
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data
						that.cartList = detail.goodslist;
						that.offerEditForm.category = detail.category, that.offerEditForm.customer_id = detail
							.customer_id, that.offerEditForm.remarks = detail.remarks, that.offerEditForm
							.order_number = detail.order_number;
						that.getType(), that.loading = !1
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getType(e) {
				let that = this,
					types = [{
						id: '',
						name: '全部分类'
					}]
				that.$fetch('addons/hlm/api.Goods/getCategory', {
					pid: that.offerEditForm.category,
					isColl: 1
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.types = types.concat(res.data)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Cooperation/getGoodsList', {
					page: that.page,
					limit: that.limit,
					order_number: sessionStorage.getItem("order_number"),
					isColl: 1,
					pid: that.offerEditForm.category,
					search: that.search,
					category_id: that.types[that.typeIndex].id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.goodList = res.data.list
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 删除商品
			delGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Cooperation/del', {
					cart_id: that.cartList[e].id,
					order_number: sessionStorage.getItem("order_number"),
					isColl: 1,
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartList.splice(e, 1), that.getTotal();
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				row.index = rowIndex;
			},
			// 编辑商品
			editCart(e) {
				let that = this;
				that.goodActive = e.id ? e.index : e;
				that.$fetch('addons/hlm/api.Cooperation/goodsDetails', {
					cart_id: e.id ? e.id : that.cartList[e].id,
					order_number: sessionStorage.getItem("order_number"),
					isColl: 1
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: "",
						};
						that.good = res.data, that.skuActive = -1, that.cartStatus = !0;
						for (let key in that.cartForm) {
							that.cartForm[key] = that.good.cart_info[key];
						}
						that.cartForm.cart_id = that.good.cart_info.id;
						that.good.valuation_tips = that.good.cart_info.valuation_tips;
						that.good.valuation = that.good.cart_info.goods_valuation;
						that.good.is_sku = that.good.cart_info.sku_ids !== "" ? 1 : 0;
						that.good.singleton = that.good.cart_info.singleton, that.good.goods_areas = that.good
							.cart_info.goods_areas;
						that.good.is_sku = that.good.cart_info.sku_ids !== "" ? 1 : 0;
						that.good.parameterList = normalizeParameterList(
							that.good.parameterList,
							that.good.cart_info.parameter_ids,
						);
						if (that.good.is_sku == 1) {
							that.good.skuPrice.forEach((price, indexP) => {
								price.skuIds = price.goods_sku_ids.split(",");
								if (price.goods_sku_ids == that.good.cart_info.sku_ids) that.good.cart_info
									.skuIds = price.goods_sku_ids.split(",");
							});
							that.good.skuList.forEach((item, index) => {
								item.children.forEach((child, idx) => {
									if (child.id == that.good.cart_info.skuIds[index]) item
										.activeId = child.id, item.activeIndex = idx;
								});
							});
							that.setStock();
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 合计总价
			getTotal() {
				let that = this,
					total = 0;
				that.cartList.forEach((item, index) => {
					total = accAdd(total, parseFloat(item.goods_original_price))
				})
				that.offerEditForm.totalAll = total
				if (total > 0) total = accSub(total, that.offerEditForm.preferential) <= 0.01 ? 0.01 : accSub(total, that
					.offerEditForm.preferential)
				that.offerEditForm.total = total
			},
			// 添加产品
			showGood(e) {
				let that = this
				that.getGood(), that.goodStatus = !0, that.good = null
			},
			searchGood(e) {
				let that = this
				that.goodList = [], that.getGood()
			},
			changeType(e) {
				let that = this
				that.typeIndex = e, that.goodList = [], that.getGood()
			},
			selectGood(e) {
				let that = this
				that.good = e
			},
			onGoodRowClick(row) {
				if (typeof window !== 'undefined' && window.innerWidth <= 768 && row) {
					this.chooseGood(row)
				}
			},
			chooseGood(e) {
				let that = this
				that.$fetch('addons/hlm/api.Cooperation/getGoodsDetails', {
					goods_id: e.id,
					order_number: sessionStorage.getItem("order_number"),
					isColl: 1
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.cartForm = {
							cart_id: "",
							goods_id: "",
							sku_ids: "",
							goods_long: "",
							goods_wide: "",
							goods_high: "",
							goods_thick: "",
							reference_image: "",
							remarks: "",
							goods_num: 1,
							goods_category: "",
							order_number: "",
							goods_size: "",
							parameter_ids: "",
						};
						that.good = res.data, that.skuActive = -1, that.cartStatus = !0;
						that.cartForm.goods_id = that.good.id, that.cartForm.goods_category = that.offerEditForm
							.category, that.cartForm.order_number = that.offerEditForm.order_number;
						that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
						if (that.good.is_sku == 1) {
							that.good.skuList.forEach((item, index) => {
								item.activeId = "", item.activeIndex = -1;
							});
							that.good.skuPrice.forEach((price, indexP) => {
								price.skuIds = price.goods_sku_ids.split(",");
							});
							that.setStock();
						}
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			addGood(e) {
				let that = this
				if (that.good) {
					that.$fetch('addons/hlm/api.Cooperation/getGoodsDetails', {
						goods_id: that.good.id,
						order_number: sessionStorage.getItem("order_number"),
						isColl: 1
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.cartForm = {
								cart_id: "",
								goods_id: "",
								sku_ids: "",
								goods_long: "",
								goods_wide: "",
								goods_high: "",
								goods_thick: "",
								reference_image: "",
								remarks: "",
								goods_num: 1,
								goods_category: "",
								order_number: "",
								goods_size: "",
								parameter_ids: "",
							};
							that.good = res.data, that.skuActive = -1, that.cartStatus = !0;
							that.cartForm.goods_id = that.good.id, that.cartForm.goods_category = that
								.offerEditForm.category, that.cartForm.order_number = that.offerEditForm
								.order_number;
							that.good.parameterList = normalizeParameterList(that.good.parameterList, null);
							if (that.good.is_sku == 1) {
								that.good.skuList.forEach((item, index) => {
									item.activeId = "", item.activeIndex = -1;
								});
								that.good.skuPrice.forEach((price, indexP) => {
									price.skuIds = price.goods_sku_ids.split(",");
								});
								that.setStock();
							}
						}
					}).catch(function(error) {
						console.log(error)
					})
				} else {
					that.$message({
						message: '请选择需要添加的产品',
						center: !0,
						type: 'warning',
						duration: 1500
					})
				}
			},
			isNestedParam,
			leafOptionsForMid,
			selectMidParam(index) {
				const item = onMidParameterChange(this.good.parameterList[index], this.good.parameterList[index].activeMidId);
				this.$set(this.good.parameterList, index, { ...item });
				this.priceInit();
			},
			// 选择参数
			selectParam(val, index) {
				let that = this;
				const param = that.good.parameterList[index];
				if (isNestedParam(param)) {
					onLeafParameterChange(param, val);
				} else {
					flatLeafParameterChange(param, val);
				}
				that.$set(that.good.parameterList, index, { ...param });
				that.priceInit();
			},
			// 选择规格
			selectSpec(idx, index) {
				let that = this;
				if (that.good.skuList[index].children[idx].noStock) return;
				that.good.skuList = that.good.skuList.map((sku, indexS) => {
					if (indexS === index) {
						if (sku.activeIndex === idx) {
							sku.activeIndex = -1, sku.activeId = "";
						} else {
							sku.activeIndex = idx, sku.activeId = sku.children[idx].id;
						}
					}
					return sku;
				});
				that.priceInit(), that.setStock();
			},
			// 设置规格状态
			setStock() {
				let that = this,
					isActive = !0;
				that.specIds = [];
				that.good.skuList.forEach((item, index) => {
					that.specIds.push(item.activeId);
				});
				let specIds = that.specIds.join(",");
				that.good.skuPrice.forEach((price, indexP) => {
					if (specIds === price.goods_sku_ids) that.skuActive = indexP, isActive = !1;
				});
				if (isActive) that.skuActive = -1;
				syncSwitchParameterVisibility(that, that.good, that.skuActive);
				that.good.skuList.forEach((item, index) => {
					item.children.forEach((child, idx) => {
						let ids = that.specIds.map((specId) => {
								return specId
							}),
							num = 0;
						ids[index] = child.id;
						that.good.skuPrice.forEach((price, indexP) => {
							let skuIds = ids.map((spec, indexS) => {
								if (spec === "") spec = price.skuIds[indexS];
								return spec;
							});
							let skuIdText = skuIds.join(",");
							if (skuIdText === price.goods_sku_ids && price.status == "up") num++;
						});
						if (num === 0) {
							child.noStock = 1;
						} else {
							child.noStock = 0;
						}
					});
				});
			},
			priceInit() {
				let that = this;
				that.$set(that.good, "goods_areas", ""), that.$set(that.good, "singleton", "");
			},
			shouldShowParameterItem(item) {
				return isParameterItemVisible(item, this.good, this.skuActive)
			},
			// 测算
			calPrice() {
				let that = this
				let params = that.cartForm,
					specNum = 0,
					paramNum = 0;
				if (that.good.is_sku == 1) {
					that.good.skuList.forEach((item, index) => {
						if (item.activeId !== "") {
							specNum++;
						}
					});
				}
				if (that.good.is_sku == 1 && specNum !== that.good.skuList.length) {
					that.$message({
						message: `请选择${that.good.skuList[specNum].name}`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if (that.good.is_sku == 1) {
					let sku_ids = that.good.skuList.map((item, index) => {
						return item.activeId;
					});
					let sku_idText = sku_ids.join(",");
					that.good.skuPrice.forEach((item, index) => {
						if (item.goods_sku_ids === sku_idText) params.sku_ids = item.id;
					});
				};
				params.parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
				if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_long===""){
					that.$message({
						message: `请输入产品长度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.cartForm.goods_high===""){
					that.$message({
						message: `请输入产品高度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_wide===""){
					that.$message({
						message: `请输入产品宽度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				if(that.good.valuation==9&&that.cartForm.goods_thick===""){
					that.$message({
						message: `请输入产品厚度`,
						type: 'warning',
						duration: 1500,
						center: !0
					});
					return;
				}
				that.$post('addons/hlm/api.Cart/getPirec', params).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.$set(that.good, "goods_areas", res.data.goods_areas), that.$set(that.good,
							"singleton", res.data.singleton), that.$forceUpdate();
						that.$message({
							message: '测算成功',
							type: 'success',
							duration: 1500,
							center: !0,
							onClose() {

							}
						});
						console.log(that.good)
					} else {}
				}).catch(function(error) {
					console.log(error)
				})
			},
			submitCart(cartForm) {
				let that = this
				if (that.cartSubmit) return;
				that.$refs[cartForm].validate((valid) => {
					if (valid) {
						let params = that.cartForm,
							sku_ids = [];
						if (that.good.is_sku == 1) {
							that.good.skuList.forEach((item, index) => {
								if (item.activeId !== "") {
									sku_ids.push(item.activeId);
								} else {
									that.$message({
										message: `请选择${item.name}`,
										type: 'warning',
										duration: 1500,
										center: !0
									});
									throw new Error("emptySku");
								}
							});
							if (sku_ids.length < that.good.skuList.length) return;
							let sku_idText = sku_ids.join(",");
							that.good.skuPrice.forEach((item, index) => {
								if (item.goods_sku_ids === sku_idText) params.sku_ids = item.id;
							});
						}
						params.parameter_ids = collectParameterIds(that.good.parameterList, that.good, that.skuActive);
						if((that.good.valuation==2||that.good.valuation==3||that.good.valuation==4||that.good.valuation==5||that.good.valuation==8||that.good.valuation==10||that.good.valuation==11||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_long===""){
							that.$message({
								message: `请输入产品长度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==6||that.good.valuation==7||that.good.valuation==9)&&that.cartForm.goods_high===""){
							that.$message({
								message: `请输入产品高度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if((that.good.valuation==4||that.good.valuation==5||that.good.valuation==6||that.good.valuation==7||that.good.valuation==9||that.good.valuation==12||that.good.valuation==13)&&that.cartForm.goods_wide===""){
							that.$message({
								message: `请输入产品宽度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						if(that.good.valuation==9&&that.cartForm.goods_thick===""){
							that.$message({
								message: `请输入产品厚度`,
								type: 'warning',
								duration: 1500,
								center: !0
							});
							return;
						}
						that.cartSubmit = !0;
						params.order_number = sessionStorage.getItem("order_number"), params.isColl = 1;
						that.$post('addons/hlm/api.Cooperation/changeCart', params).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.cartList = res.data, that.cartStatus = !1, that.goodStatus = !1, that
									.good = null, that.specIds = [], that.getTotal(), that.cartSubmit = !1;
								that.$message({
									message: that.cartForm.cart_id === "" ? '添加成功' : "修改成功",
									type: 'success',
									duration: 1000,
									center: !0,
									onClose() {}
								});
							} else {
								that.cartSubmit = !1;
							}
						}).catch(function(error) {
							console.log(error)
							that.cartSubmit = !1;
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			submitForm(offerEditForm) {
				let that = this
				that.$message({
					message: '编辑成功',
					type: 'success',
					duration: 1500,
					center: !0,
					onClose() {
						that.quotationStatus = !1
					}
				});
				// if (that.quotationStatus) return
				// that.$refs[offerEditForm].validate((valid) => {
				// 	if (valid) {
				// 		let params = that.offerEditForm
				// 		if (params.total === 0) {
				// 			that.$message({
				// 				message: '请添加产品',
				// 				type: 'warning',
				// 				duration: 1500,
				// 				center: !0
				// 			})
				// 			return
				// 		}
				// 		that.quotationStatus = !0
				// 		params.offertime = getTimestamp(params.createTime)
				// 		params.order_number = sessionStorage.getItem("order_number"),params.isColl = 1;
				// 		that.$post('addons/hlm/api.Cooperation/orderUpdate', params).then(function(res) {
				// 			console.log(res)
				// 			if (res.code == 1) {
				// 				that.$message({
				// 					message: '编辑成功',
				// 					type: 'success',
				// 					duration: 1500,
				// 					center: !0,
				// 					onClose() {
				// 						that.quotationStatus = !1
				// 					}
				// 				});
				// 			} else {
				// 				that.quotationStatus = !1
				// 			}
				// 		}).catch(function(error) {
				// 			console.log(error)
				// 			that.quotationStatus = !1
				// 		})
				// 	} else {
				// 		console.log('error submit!!');
				// 		return false;
				// 	}
				// });
			},
			// 上下移动
			upLayer(index, row) {
				var that = this;
				if (index == 0) {
					that.$message({
						message: "处于顶端，不能继续上移",
						center: !0,
						type: "warning"
					});
				} else {
					let upDate = that.cartList[index - 1]
					that.cartList.splice(index - 1, 1)
					that.cartList.splice(index, 0, upDate)
				}
			},
			downLayer(index, row) {
				var that = this;
				if (index + 1 === that.cartList.length) {
					that.$message({
						message: "处于末端端，不能继续下移",
						center: !0,
						type: "warning"
					});
				} else {
					let downDate = that.cartList[index + 1]
					that.cartList.splice(index + 1, 1)
					that.cartList.splice(index, 0, downDate)
				}
			},
			sizeSpan({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 4) {
					// if (columnIndex === 0) {
					// 	return [1, 2];
					// } else if (columnIndex === 1) {
					// 	return [0, 0];
					// }
				}
			},
			printQuotation() {
				let that = this
			},
			printInvoice() {
				let that = this
			},
			goBack() {
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/offerEdit.css'>
	/* px2rem能正常转换 */
</style>
